<template>
    <div class="settings-panel">
        <div class="settings-panel__inner">
            <mds-section
                :size="7"
                :collapsible="includeBenchmark"
                e2e="benchmark-section"
                bold
                ref="section"
                border="secondary"
                @mds-section-expanded="expandSection"
                @mds-section-closed="closeSection"
            >
                <template v-slot:mds-section-title>
                    <div>
                        <mds-icon v-if="hasError && includeBenchmark" name="alert-fill" size="small" class="alert-icon"></mds-icon>
                        <span :class="{ 'benchmark--disabled': !includeBenchmark }">
                            {{ getUILabel(text) }}
                        </span>
                    </div>
                </template>
                <template v-slot:mds-section-actions>
                    <mds-switch e2e="benchmark-section-switch" :checked="includeBenchmark" @change="changeIncludeBenchmark">{{
                        getUILabel("common_include")
                    }}</mds-switch>
                </template>
                <template v-slot:default>
                    <benchmark-content :mwcId="getMwcIdForChild('content')" ref="benchmark" @valid-benchmark-error="handleError"></benchmark-content>
                </template>
            </mds-section>
            <benchmark-summary v-if="!expanded && includeBenchmark" :mwcId="getMwcIdForChild('summary')"></benchmark-summary>
        </div>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import BenchmarkSummary from "./Summary";
import BenchmarkContent from "./Benchmark";
import { mapState } from "vuex";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsIcon from "@mds/icon";
import MdsSection from "@mds/section";
import MdsSwitch from "@mds/switch";

export default {
    name: "benchmark-panel",
    props: {
        text: String
    },
    components: {
        BenchmarkSummary,
        BenchmarkContent,
        MdsIcon,
        MdsSection,
        MdsSwitch
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            hasError: false,
            expanded: false
        };
    },
    mounted() {
        if (this.includeBenchmark) {
            this.$refs.benchmark.initBenchmarkHoldings();
        }
    },
    computed: {
        ...mapState("benchmark", ["includeBenchmark"])
    },
    methods: {
        expandSection() {
            this.expanded = true;
        },
        closeSection() {
            this.expanded = false;
        },
        handleError(error) {
            this.hasError = !!error.payload;
            this.$emit("on-error", error);
        },
        changeIncludeBenchmark(value, event) {
            this.$refs.benchmark && this.$refs.benchmark.changeIncludeBenchmark(value);
            this.$refs.section.toggle(event);
        }
    },
    watch: {
        expanded(value) {
            if (value) {
                this.$refs.benchmark && this.$refs.benchmark.initBenchmarkHoldings();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/constants";
@import "@mds/icon/src/icon_mixins";
.benchmark--disabled {
    color: #9b9b9b;
}
.alert-icon {
    @include mds-icon-color($mds-text-color-error);
    position: relative;
    top: 2px;
}
</style>
;
